module.exports = "interfaces"